/** Emergent-managed Google sign-in · AuthCallback + MemberBadge
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");
    (async () => {
      let user = null;
      if (sessionId) {
        try {
          const r = await fetch(`${API}/auth/session`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ session_id: sessionId }),
          });
          if (r.ok) user = await r.json();
        } catch { /* noop */ }
      }
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      navigate("/", { replace: true, state: user ? { user } : undefined });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0a0a0f" }}>
      <p data-testid="auth-callback-status" className="font-mono uppercase tracking-[0.24em]" style={{ color: "#FFD700", fontSize: 13 }}>
        ◈ Sealing your Federation credentials…
      </p>
    </div>
  );
}

export function MemberBadge() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(location.state?.user || null);
  const [checked, setChecked] = useState(!!location.state?.user);

  useEffect(() => {
    if (checked) return;
    // CRITICAL: skip /me if returning from OAuth — AuthCallback owns the exchange
    if (window.location.hash?.includes("session_id=")) { setChecked(true); return; }
    fetch(`${API}/auth/status`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => { if (s && s.authenticated) setUser(s.user); })
      .catch(() => {})
      .finally(() => setChecked(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state?.user) { setUser(location.state.user); setChecked(true); }
  }, [location.state]);

  const signIn = () => navigate("/login");

  const signOut = async () => {
    await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" }).catch(() => {});
    setUser(null);
  };

  if (!checked) return null;
  if (!user) {
    return (
      <button
        type="button"
        data-testid="member-sign-in-btn"
        onClick={signIn}
        className="font-mono text-[10px] uppercase tracking-[0.2em]"
        style={{
          minHeight: 30, padding: "0 12px", color: "#FFD700",
          background: "transparent", border: "1px solid rgba(255,215,0,0.55)",
          borderRadius: 999, cursor: "pointer",
        }}
      >
        ⎆ Sign In
      </button>
    );
  }
  return (
    <span className="inline-flex items-center gap-2" data-testid="member-badge">
      {user.picture && (
        <img src={user.picture} alt="" referrerPolicy="no-referrer"
             style={{ width: 22, height: 22, borderRadius: "50%", border: "1px solid rgba(255,215,0,0.6)" }} />
      )}
      <span data-testid="member-name" className="font-mono text-[10px] uppercase tracking-[0.16em]" style={{ color: "#FFD700", maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {user.name || user.email}
      </span>
      <button
        type="button"
        data-testid="member-sign-out-btn"
        onClick={signOut}
        className="font-mono text-[9px] uppercase tracking-[0.16em]"
        style={{
          minHeight: 26, padding: "0 8px", color: "rgba(224,224,224,0.7)",
          background: "transparent", border: "1px solid rgba(224,224,224,0.3)",
          borderRadius: 999, cursor: "pointer",
        }}
      >
        Sign Out
      </button>
    </span>
  );
}
